import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import routes from "Routes";
import Dashboard from "Components/Dashboard";
import DesktopLogin from "Auth/Login";
import PrivateRoute, { isAuthenticated } from "utils/Authenticated";


const App = () => {
  return (
    <>
      {/* <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={isAuthenticated() ? <Dashboard /> : <Navigate to="/login" />}
          />
          {routes.map((route) => {
            return (
              <Route
                key={route.id}
                path={route.path}
                element={<Layout component={route.component} />}
              />
            );
          })}
        </Routes>
      </BrowserRouter> */}



      <BrowserRouter>
        <Routes>
          {/* Public Route */}
          <Route path="/login" element={<DesktopLogin />} />




          {routes.map((route) => (
            <Route
              key={route.id}
              path={route.path}
              element={
                <PrivateRoute>

                  <Layout component={route.component} /></PrivateRoute>


              }
            />
          ))}
        </Routes>
      </BrowserRouter>

    </>
  );
};

export default App;
